// extracted by mini-css-extract-plugin
export default {"collageImage":"preview_collageImage__Qyvs0","zoomSelectionContainer":"preview_zoomSelectionContainer__q6vsl","imageZoomContainer":"preview_imageZoomContainer__CtGna"};